import { all } from 'redux-saga/effects'

import { watchIncrementAsync } from '@/saga/counter'
import {
    watchQueryIndicator,
    watchQuerySituation,
    watchQueryTemperature,
    watchQueryOrder,
    watchQueryOperation,
    watchQueryOperationImage,
    watchQuerySize
} from '@/saga/dashboard'

export default function* rootSaga() {
    yield all([
        watchIncrementAsync(),
        watchQueryIndicator(),
        watchQuerySituation(),
        watchQueryTemperature(),
        watchQueryOrder(),
        watchQueryOperation(),
        watchQueryOperationImage(),
        watchQuerySize()
    ])
}